// Filter constants - no need for API endpoint since these are fixed values

export const AVAILABLE_LEVELS = [
  "BEGINNER",
  "ELEMENTARY",
  "INTERMEDIATE",
  "UPPER_INTERMEDIATE",
  "ADVANCED",
  "PROFICIENT",
] as const;

export const TEXT_SIZES = ["SHORT", "MEDIUM", "LONG"] as const;

export type Level = (typeof AVAILABLE_LEVELS)[number];
export type TextSize = (typeof TEXT_SIZES)[number];
